// The two project reads the shell needs (nav v2's switcher), without the Xano client.
//
// THE SHELL MUST NOT IMPORT lib/xano.ts (scripts/check-startup-bundle.mjs fails the build if it does), and the
// generated client imports it, so the switcher reads GET admin/projects and GET admin/project here with plain fetch.
// Same endpoints, same answers and the SAME QUERY KEYS as routes/Projects.tsx (["projects"]) and
// routes/ProjectDetail.tsx (["project", id]), so the screens and the switcher share one cache entry each.
import { tokenStore } from "./authTransport";
import { CMS_BASE } from "./xanoBases";
import type { ProjectDetail, ProjectSummary } from "./xano";
import type { ProjectRef } from "./projectScope";

/** A row of GET admin/projects, with the fields xano/project-workspaces adds (absent until it is pushed). */
export type ProjectListItem = ProjectSummary & Pick<ProjectRef, "site_ids" | "data_workspace_id">;

export const projectsKey = ["projects"] as const;
export const projectKey = (id: number) => ["project", id] as const;

async function cms<T>(path: string, query: Record<string, string | number> = {}, signal?: AbortSignal): Promise<T> {
  const base = /^https?:\/\//i.test(CMS_BASE) ? CMS_BASE : window.location.origin + (CMS_BASE.startsWith("/") ? CMS_BASE : `/${CMS_BASE}`);
  const url = new URL(path, base.replace(/\/?$/, "/"));
  for (const [k, v] of Object.entries(query)) url.searchParams.set(k, String(v));
  const token = tokenStore.get();
  const res = await fetch(url, { signal, headers: { Accept: "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) } });
  const body = (await res.json().catch(() => null)) as (T & { message?: string }) | null;
  if (!res.ok) throw new Error(body?.message || `Request failed (${res.status})`);
  return body as T;
}

/** Every project you own or are on. An answer without a `projects` list is read as none, never as a failure. */
export async function listProjects(signal?: AbortSignal): Promise<{ projects: ProjectListItem[] }> {
  const body = await cms<{ projects?: unknown }>("admin/projects", {}, signal);
  const rows = Array.isArray(body?.projects) ? (body.projects as ProjectListItem[]) : [];
  return { projects: rows.filter((p) => p && Number.isSafeInteger(p.id) && p.id > 0 && typeof p.name === "string") };
}

/** One project: its sites (by Xano site id) and members. */
export function getProject(id: number, signal?: AbortSignal): Promise<ProjectDetail & Pick<ProjectRef, "data_workspace_id">> {
  return cms("admin/project", { project_id: id }, signal);
}
